import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-block" }, "Zustandsbeschreibung", -1);
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "row no-gutters pt-45 px-sm-5 px-3" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "font6-responsive text-sm-center" }, " Alle unsere Geräte sind voll funktionsfähig und wurden professionell gereinigt und desinfiziert. Außerdem wird jedes Gerät durch zertifizierte Techniker:innen auf 58 Qualitätsmerkmale wie Akku, Display, Kamera und mehr geprüft und anschließend professionell refurbished. Anschließend bewerten unsere Mitarbeitenden den optischen Zustand des Geräts und ordnen es einem der folgenden Gerätezustände zu. ")
], -1);
const _hoisted_6 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_single_condition = _resolveComponent("single-condition");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        class: "conditionsPopup",
        modelValue: _ctx.openPopup,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.openPopup) = $event)),
        width: "800",
        "max-height": "80vh"
    }, {
        default: _withCtx(({ isActive }) => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("i", {
                            onClick: ($event) => (isActive.value = false),
                            class: "icon-cancel pointerhover float-right pr-2"
                        }, null, 8, _hoisted_3)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "entry"
                                }, [
                                    _createVNode(_component_single_condition, {
                                        answer: entry === null || entry === void 0 ? void 0 : entry.answer,
                                        question: entry === null || entry === void 0 ? void 0 : entry.question,
                                        image: entry === null || entry === void 0 ? void 0 : entry.image
                                    }, null, 8, ["answer", "question", "image"])
                                ]));
                            }), 128))
                        ])
                    ])
                ]),
                _: 2
            }, 1024)
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
